import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
export const schedulingEditorHostStyleId = 'wb-v2-surface-scheduling-editor-host-theme';
export const schedulingEditorHostBridgeStyles = {
  'wb-surface-scheduling-editor-host': {
    '--local-scheduling-editor-background': tokens.color.background.primary,
    '--local-scheduling-editor-text': tokens.color.text.primary,
    '--local-scheduling-editor-muted': tokens.color.text.secondary,
    '--local-scheduling-editor-border': tokens.color.border.secondary,
    '--local-scheduling-editor-padding': tokens.spacing.lg,
    '--local-scheduling-editor-tab-padding': tokens.spacing.md,
    '--local-scheduling-editor-gap': tokens.spacing.lg,
    '--local-scheduling-editor-title-size': tokens.font.size.textLg,
    '--local-scheduling-editor-text-size': tokens.font.size.textSm,
    '--local-scheduling-editor-weight': tokens.font.weight.semibold,
    '--local-scheduling-editor-error-background': tokens.color.background.errorPrimary,
    '--local-scheduling-editor-error-text': tokens.color.text.errorPrimary,
    '--local-scheduling-editor-radius': tokens.radius.md,
    '--local-scheduling-editor-focus': tokens.color.border.brand,
  },
};
